"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteApprovedFeedstocksService = exports.editApprovedFeedstockService = exports.createApprovedFeedstockService = exports.getApprovedFeedstocksService = void 0;
const api_1 = require("@/services/api");
const CustomError_1 = __importDefault(require("@/domains/Utilities/CustomError"));
const ENDPOINT = "/approved-feedstocks";
function getApprovedFeedstocksService() {
    return api_1.axiosInstance
        .get(ENDPOINT)
        .then((response) => {
        return response.data.rows;
    })
        .catch((error) => {
        throw new Error(`[Approved Feedstock Error]: ${error}`);
    });
}
exports.getApprovedFeedstocksService = getApprovedFeedstocksService;
function createApprovedFeedstockService(payload) {
    return api_1.axiosInstance
        .post(`${ENDPOINT}`, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while creating approved feedstock", error?.response?.status);
    });
}
exports.createApprovedFeedstockService = createApprovedFeedstockService;
function editApprovedFeedstockService(feedstockId, payload) {
    return api_1.axiosInstance
        .patch(`${ENDPOINT}/${feedstockId}`, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while editing approved feedstock", error?.response?.status);
    });
}
exports.editApprovedFeedstockService = editApprovedFeedstockService;
function deleteApprovedFeedstocksService(feedstockId) {
    return api_1.axiosInstance
        .delete(`${ENDPOINT}/${feedstockId}`)
        .then((response) => {
        return response.status;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while deleting approved feedstock", error?.response?.status);
    });
}
exports.deleteApprovedFeedstocksService = deleteApprovedFeedstocksService;
//TODO: FIX TYPESCRIPT
